<template>
  <div>
    
    <table class="final-table th-no-padding lines-b pointer hover full-width">
      <colgroup ref="colgroup1">
        <col width="30px">
      </colgroup>

      <draggable 
      :list="items"
      :element="'tbody'"
      :options="{animation: 150, handle: '.drag-handle'}"
      >
      <v-hover
      v-slot:default="{ hover }"
      v-for="(item, i) in items" :key="item.id"
      >
        <row
        :item="item"
        :hover="hover"
        :active="currentIndex === i"
        :currentSelection="item.id === currentSelectedID"
        @click.native="clickRow(item)"
        @onDelete="onDeleteItem"
        ></row>
      </v-hover>
      </draggable>

      <!--
      <draggable 
      :list="paginatedArray"
      :element="'tbody'"
      :options="{animation: 150, handle: '.drag-handle'}"
      @change="dragChange">
        <list-row
        v-for="item in paginatedArray" 
        :key="item.tempID"
        vmode="table"
        :currency="formData.currency"
        :priceList="priceList"
        :item="item"
        :selected="selected"
        :sortIndex="sortIndex"
        :searchText="searchText"
        @checkRow="checkRow(item)"
        @click.native="clickRow(item)"
        ></list-row>
      </draggable>
      -->

    </table>

    <v-row class="pa-2">
      <v-btn outlined @click="addColumn" text color="color1">
        <v-icon color="textSecondary">mdi-plus</v-icon>
        Add column
      </v-btn>
    </v-row>


  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import Row from './row.vue'
import ServerListKeyboardBindings from '@/mixins/ServerListKeyboardBindings'

export default {
  components: {
    Row,
    Draggable
  },
  mixins: [ServerListKeyboardBindings],
  props: {
    items: null
  },
  data () {
    return {
      currentIndex: -1 // override ServerListKeyboardBindings to prevent item 0 automatically being highlighted
    }
  },
  methods: {
    clickRow (item) {
      this.currentIndex = this.items.indexOf(item)
      if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        // this.$router.push('/inventory/inventory-definition/view/' + item.id)
        this.$emit('onItemSelected', item)
      }
    },
    addColumn () {
      this.items.push({
        name: 'New column',
        editable: true,
        _schema: {
          _type: null,
          _default: null,
          _not_null: false
        }
      })
    },
    onDeleteItem (item) {
      var index = this.items.indexOf(item)
      this.items.splice(index, 1)
    }
  }
}
</script>